import { Injectable } from '@angular/core';
import { IMetaDataExtended } from '@df/core/meta/meta-state';
import { GtmProvider } from '@df/module-gtm/gtm-provider.service';

@Injectable({
    providedIn: 'root'
})
export class GtmProviderDecorator extends GtmProvider {
    override get pageType(): string | undefined {
        const pageType = super.pageType;

        if (pageType) {
            return pageType;
        }

        const previousPageType = (this.meta.previousState?.metaData as IMetaDataExtended)?.pageType;

        return previousPageType;
    }
}
